import { ProductTypeEnum } from "@kanpla/api-contract";

import { type Product, type Category } from "~/api/products/types";

import { type ProductBasicWithTaxRate } from "../../types";

type ParseInProductsBasicArgs = {
  products: Product[];
  categories: Category[];
};

export function parseInProductsBasic({
  products,
  categories
}: ParseInProductsBasicArgs): ProductBasicWithTaxRate[] {
  const productsBasic: ProductBasicWithTaxRate[] = [];

  for (const product of products) {
    const category = categories.find(
      (category) => category.id === product.categoryId
    )?.name;

    const productBasicBase: ProductBasicWithTaxRate = {
      id: product.id,
      name: product.name,
      description: product.description ?? undefined,
      categoryId: product.categoryId,
      category: category ?? "unknown",
      productLineId: product.productLineId,
      deadline: product.deadline,
      onset: product.onset,
      barcodeIds: product.barcodeIds,
      vatRate: product.taxRate.vatRate,
      unitPrice: product.unitPriceInclVat,
      exclVatUnitPrice: product.unitPriceExclVat,
      color: product.color ?? undefined,
      discount: product.discount,
      taxRateId: product.taxRate.id,
      taxRateName: product.taxRate.name,
      userLimitId: product.userLimitId,
      options: [],

      containerWeight: 0,
      unitSystem: "piece",
      deposit: product.deposit,
      stock: product.stock,
      tags: product.tags
    };

    if (product.type === ProductTypeEnum.WEIGHTED) {
      productsBasic.push({
        ...productBasicBase,
        unitSystem: product.unitSystem,
        containerWeight: product.containerWeight
      });
      continue;
    }

    if (product.type === ProductTypeEnum.VARIANTS) {
      productsBasic.push({
        ...productBasicBase,
        options: product.options
      });
      continue;
    }
    productsBasic.push(productBasicBase);
  }

  return productsBasic;
}
